// extracted by mini-css-extract-plugin
export default {"loginPage":"LoginPage_loginPage__eZ30b","form_container":"LoginPage_form_container__ONSHh","image_container":"LoginPage_image_container__aK48b"};